import React from 'react';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/logo-rccb.png" 
                alt="RCCB Logo" 
                className="h-16 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-gray-400 mb-4">
              Votre partenaire de confiance pour tous vos travaux de peinture, plâtrerie, plomberie, sols, carrelage et bricolage.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Nos Services</h4>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="hover:text-blue-400 transition-colors duration-200">
                  Peinture
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-blue-400 transition-colors duration-200">
                  Plâtrerie
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-blue-400 transition-colors duration-200">
                  Plomberie
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-blue-400 transition-colors duration-200">
                  Sols et Carrelage
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-blue-400 transition-colors duration-200">
                  Bricolage
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-blue-400 transition-colors duration-200">
                  Devis gratuit
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Liens Rapides</h4>
            <ul className="space-y-2">
              <li>
                <a href="#accueil" className="hover:text-blue-400 transition-colors duration-200">
                  Accueil
                </a>
              </li>
              <li>
                <a href="#apropos" className="hover:text-blue-400 transition-colors duration-200">
                  À propos
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-blue-400 transition-colors duration-200">
                  Services
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-blue-400 transition-colors duration-200">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="text-blue-400 flex-shrink-0 mt-1" size={18} />
                <span>07.56.92.22.30</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="text-blue-400 flex-shrink-0 mt-1" size={18} />
                <span>contact.rccb@gmail.com</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="text-blue-400 flex-shrink-0 mt-1" size={18} />
                <span>12 rue de Cuire<br />69004 Lyon<br />Intervention régionale</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} RCCB. Tous droits réservés.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="hover:text-blue-400 transition-colors duration-200">
                Mentions légales
              </a>
              <a href="#" className="hover:text-blue-400 transition-colors duration-200">
                Politique de confidentialité
              </a>
              <a href="#" className="hover:text-blue-400 transition-colors duration-200">
                CGV
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
